// extracted by mini-css-extract-plugin
module.exports = {"add":"TeamGeneralSettings_add__1tdIl","remove":"TeamGeneralSettings_remove__3VYBS"};